<template>
  <div
    class="content contentAlignment pt-5"
    :key="activePanel"
    :class="{ 'color-background': isCustomerDetailsView }"
  >
    <div v-if="selectedUser || isDODView" class="leftBar pt-0 m-0">
      <template v-if="selectedUser">
        <left-bar />
      </template>
      <template v-else-if="isDODView && (hasDodAccess || hasPodAccess)">
        <left-bar-dod />
      </template>
    </div>
    <div
      class="p-0 ml-4 mr-4 mainBlockFullSize"
      :class="{
        mainBlockNotFullSize: selectedUser,
        'overflow-x-auto':
          this.$route.path === '/dod-add-customer-and-employee',
      }"
    >
      <router-view class="p-0 m-0"></router-view>
    </div>
  </div>
</template>

<script>
import LeftBar from "./LeftBar";
import LeftBarDOD from "./LeftBarDOD.vue";

export default {
  components: {
    leftBar: LeftBar,
    leftBarDod: LeftBarDOD,
  },

  computed: {
    selectedUser() {
      return this.$store.getters.getSelectedUser;
    },
    isDODView() {
      return this.$store.getters.getDODView;
    },
    activePanel() {
      return this.$store.getters.getActivePanel;
    },
    hasDodAccess() {
      const loggedAdmin = JSON.parse(
        window.localStorage.getItem("loggedAdmin")
      );
      return loggedAdmin && loggedAdmin.hasDodAccess;
    },
    hasPodAccess() {
      const loggedAdmin = JSON.parse(
        window.localStorage.getItem("loggedAdmin")
      );
      return loggedAdmin && loggedAdmin.hasPodAccess;
    },
    isCustomerDetailsView() {
      return this.$route.path.includes("customer-details");
    },
  },
};
</script>

<style scoped>
.content {
  padding: 0;
  width: 100vw;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 200px;
}
.contentAlignment {
  display: flex;
  flex-direction: row;
}
.leftBar {
  margin-bottom: 60px;
  position: sticky;
  top: var(--app-header-height);
  left: 20px;
  z-index: 990;
  width: 15rem;
  min-width: 20rem;
}

.mainBlockFullSize {
  width: 99%;
}
.mainBlockNotFullSize {
  width: 80%;
}
/* @media only screen and (max-width: 700px) {
  .mainBlock {
    margin-left: 0 !important;
  }
} */
.overflow-x-auto {
  overflow-x: unset;
}
@media screen and (max-width: 1350px) {
  .overflow-x-auto {
    overflow-x: auto;
  }
}
</style>
